const getApiBaseUrl = () =>
  (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

export const getGoogleLoginUrl = () =>
  `${getApiBaseUrl()}/api/auth/google`;

export const getCurrentUser = async () => {
  const response = await fetch(`${getApiBaseUrl()}/api/auth/me`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });

  if (response.status === 401) {
    return null;
  }

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "No se pudo recuperar la sesión");
  }

  return data.user;
};

export const logout = async () => {
  const response = await fetch(`${getApiBaseUrl()}/api/auth/logout`, {
    method: "POST",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "No se pudo cerrar la sesión");
  }

  return data;
};
